import {
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  getStringHashCode26igk1bx568vk as getStringHashCode,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var ClientConfigClass;
function ClientConfig() {
  if (ClientConfigClass === VOID) {
    class $ {
      constructor(prereleaseMode, auth0ClientId, auth0Domain, basename, expressEnv, webpackPublicPath, websocketHost) {
        this.j7b_1 = prereleaseMode;
        this.k7b_1 = auth0ClientId;
        this.l7b_1 = auth0Domain;
        this.m7b_1 = basename;
        this.n7b_1 = expressEnv;
        this.o7b_1 = webpackPublicPath;
        this.p7b_1 = websocketHost;
      }
      toString() {
        return 'ClientConfig(prereleaseMode=' + this.j7b_1 + ', auth0ClientId=' + this.k7b_1 + ', auth0Domain=' + this.l7b_1 + ', basename=' + this.m7b_1 + ', expressEnv=' + this.n7b_1 + ', webpackPublicPath=' + this.o7b_1 + ', websocketHost=' + this.p7b_1 + ')';
      }
      hashCode() {
        var result = getBooleanHashCode(this.j7b_1);
        result = imul(result, 31) + getStringHashCode(this.k7b_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.l7b_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.m7b_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.n7b_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.o7b_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.p7b_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ClientConfig()))
          return false;
        if (!(this.j7b_1 === other.j7b_1))
          return false;
        if (!(this.k7b_1 === other.k7b_1))
          return false;
        if (!(this.l7b_1 === other.l7b_1))
          return false;
        if (!(this.m7b_1 === other.m7b_1))
          return false;
        if (!(this.n7b_1 === other.n7b_1))
          return false;
        if (!(this.o7b_1 === other.o7b_1))
          return false;
        if (!(this.p7b_1 === other.p7b_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'ClientConfig');
    ClientConfigClass = $;
  }
  return ClientConfigClass;
}
//region block: exports
export {
  ClientConfig as ClientConfig2mpft8d5d0hh3,
};
//endregion

//# sourceMappingURL=ClientConfig.mjs.map
